<template>
  <v-btn icon small v-bind="$attrs" @click="showLadder()" v-on="$listeners">
    <v-icon size="22"> mdi-ladder </v-icon>
  </v-btn>
</template>
<script>
import { mapState } from 'vuex'
export default {
  props: {
    sessionId: { type: Object, required: true },
    sessionName: { type: String, required: true }
  },
  data() {
    return {
      gameMode: 'SportsBook',
      valid: true
    }
  },
  computed: {
    ...mapState({
      loading: (state) => state.fancyLadders.loading
    }),
    fancyModal: {
      get() {
        return this.$store.getters['fancyLadders/modalOpen']
      },
      set(v) {
        return this.$store.commit('fancyLadders/set_modal', v)
      }
    }
  },
  methods: {
    async showLadder() {
      this.fancyModal = true
      try {
        await this.$store.dispatch('fancyLadders/getFancyLadder', {
          sessionId: this.sessionId.MarketId,
          sessionName: this.sessionName
        })
      } catch (error) {}
    }
  }
}
</script>
<style lang="scss" scoped>
.info-text {
  font-size: 10px;
  .info-icon {
    font-size: 13px;
  }
}
</style>
